import React, { Suspense } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

const SpinStyle = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: calc(100vh);
`;

const SuspenseWrapper = ({ children }) => {
  return (
    <Suspense
        fallback={
          <SpinStyle>
          <Spin />
        </SpinStyle>
        }
    >
      {children}
    </Suspense>
  )
}

export default SuspenseWrapper;